// extracted by mini-css-extract-plugin
module.exports = {"languageTag":"LanguageStatusTag_languageTag__ERiCP"};